import { Icon, IconProps } from '../Icon'

export const CheckCircleIcon = ({ color, size }: IconProps) => {
  return (
    <Icon color={color} size={size}>
      check_circle
    </Icon>
  )
}
